import React from "react";
import { Alert, Button } from "reactstrap";

const VideoResults = ({
  videoResults,
  videoStatuses,
  scenes,
  regeneratingVideo,
  checkingStatus,
  onRegenerateVideo
}) => {
  return (
    <div className="mt-4">
      <Alert color="success">
        <h6>
          <i className="fa fa-check-circle me-2"></i>Video Generation Started!
        </h6>
        <p>Total scenes: {videoResults.total_scenes}</p>
        <p>Status: {videoResults.status}</p>
        <p>Estimated completion: {videoResults.estimated_completion}</p>

        {videoStatuses.length > 0 && (
          <div className="mt-3">
            <h6>Video Status:</h6>
            <div className="row">
              {videoStatuses.map((status, index) => {
                const sceneNumber =
                  scenes.find((s) =>
                    videoResults.leonardo_jobs?.find(
                      (job) =>
                        job.leonardo_job_id === status.jobId &&
                        job.scene_number === s.scene_number
                    )
                  )?.scene_number || index + 1;

                return (
                  <div key={status.jobId} className="col-md-6 mb-3">
                    <div className="card">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>Scene {sceneNumber}</strong>
                          <span
                            className={`badge ${
                              status.status === "COMPLETE"
                                ? "bg-success"
                                : status.status === "FAILED"
                                ? "bg-danger"
                                : "bg-warning"
                            }`}
                          >
                            {status.status}
                          </span>
                        </div>
                        {status.status === "COMPLETE" && status.videoUrl ? (
                          <div>
                            <video
                              controls
                              width="100%"
                              height="150"
                              className="rounded mb-2"
                            >
                              <source src={status.videoUrl} type="video/mp4" />
                            </video>
                            <Button
                              color="warning"
                              size="sm"
                              onClick={() => onRegenerateVideo(sceneNumber - 1)}
                              disabled={regeneratingVideo === sceneNumber - 1}
                              className="w-100"
                            >
                              {regeneratingVideo === sceneNumber - 1 ? (
                                <>
                                  <i className="fa fa-spinner fa-spin me-1"></i>
                                  Regenerating...
                                </>
                              ) : (
                                <>
                                  <i className="fa fa-refresh me-1"></i>
                                  Regenerate Video
                                </>
                              )}
                            </Button>
                          </div>
                        ) : (
                          <div
                            className="bg-light rounded d-flex align-items-center justify-content-center"
                            style={{ height: "150px" }}
                          >
                            {status.status === "FAILED" ? (
                              <span className="text-danger">
                                <i className="fa fa-exclamation-triangle fa-2x"></i>
                                <br />
                                <small>Failed</small>
                              </span>
                            ) : (
                              <span className="text-muted">
                                <i className="fa fa-clock-o fa-2x"></i>
                                <br />
                                <small>Processing...</small>
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {checkingStatus && (
              <div className="text-center mt-2">
                <i className="fa fa-spinner fa-spin me-1"></i>
                <small>Checking video status...</small>
              </div>
            )}
          </div>
        )}
      </Alert>
    </div>
  );
};

export default VideoResults;